import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=326acd5b&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=326acd5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326acd5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('326acd5b')) {
      api.createRecord('326acd5b', component.options)
    } else {
      api.reload('326acd5b', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=326acd5b&scoped=true&", function () {
      api.rerender('326acd5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W4M5RXCkfo4c/JS/comp/DocBox.vue"
export default component.exports